import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ShellComponent } from './shell/shell.component';
import {RouterModule} from '@angular/router';
import {LayoutModule} from '@angular/cdk/layout';
import {QuizModule} from '../quiz/quiz.module';




const components = [ShellComponent]
const modules = [
  CommonModule,
  RouterModule,
  LayoutModule,
  QuizModule

]

@NgModule({
  declarations: [...components ],
  imports: [
    ...modules,
  ],
  exports: [
    ...components,
    ...modules
  ]
})
export class SharedModule { }
